import { render, staticRenderFns } from "./RateSection.vue?vue&type=template&id=7e64dc28&"
import script from "./RateSection.vue?vue&type=script&lang=js&"
export * from "./RateSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports